import { render, staticRenderFns } from "./MemberWallet.vue?vue&type=template&id=39939a08&"
import script from "./MemberWallet.vue?vue&type=script&lang=js&"
export * from "./MemberWallet.vue?vue&type=script&lang=js&"
import style0 from "./MemberWallet.vue?vue&type=style&index=0&id=39939a08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports